import React from 'react';

export const TsuMagIidaModal = {
  title: 'Tsunami Magnitude (Iida)',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>-5 to 10</b>
      </div>
      <br />
      <p>Tsunami magnitude (M) is defined by Iida and others (1967) as</p>
      <p>
        M = log
        <sub>2</sub>
        h
      </p>
      {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
      <p>{'where "h" is the maximum runup height of the wave.'}</p>
    </div>
  ),
};
